export const SKIP_FILE_CUSTOM_VALUE_LIMIT = {
  SKIP_FILE_NUMBER: { min: 0, max: 1000000000 },
  SKIP_FILE_PERCENTAGE: { min: 0, max: 100 },
};
